module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("la6wm"))).then(() => parcelRequire('eKxEC'));